import React from 'react';
import { Button } from 'primereact/button';
import { PrimeIcons } from 'primereact/api';
import { useThemeContext } from '../../../context/ThemeContext';

export const ThemeToggleButton = () => {
  const { theme, toggleTheme } = useThemeContext();
  const isDark = theme === 'dark';

  return (
    <Button
      type='button'
      // An icon-only look without PrimeReact's empty label span, which would add a blank entry to the drawer's labels.
      className='theme-toggle-button p-button-icon-only'
      icon={isDark ? PrimeIcons.SUN : PrimeIcons.MOON}
      aria-label={isDark ? 'Activar modo claro' : 'Activar modo oscuro'}
      onClick={toggleTheme}
    >
      <></>
    </Button>
  );
};
